import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {TtdConfig} from '../../../target/target.service';
import {ApiId} from '../../../distribution-account/distribution-account.model';
import {FormControl} from '@angular/forms';

@Component({
  selector: 'app-ttd-brand-selector',
  template: `
    <mat-form-field appearance="outline"
                    class="no-padding-bottom type-select">
      <mat-label>TTD Brand</mat-label>
      <mat-select [formControl]="brandIdControl" required (selectionChange)="out.emit($event.value)">
        <mat-option *ngFor="let option of config" [value]="option.brandId">{{ option.brandId }}
          (provider {{ option.providerId }})
        </mat-option>
      </mat-select>
    </mat-form-field>
  `,
  styleUrls: ['./ttd-brand-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TtdBrandSelectorComponent implements OnInit {
  @Input() config: TtdConfig[] = [];
  @Input() initial!: string;
  @Input() apiId!: ApiId;

  @Output() out = new EventEmitter<string>();
  brandIdControl: FormControl = new FormControl();

  ngOnInit(): void {
    this.config = this.config.filter(c => c.apiId === this.apiId);
    this.brandIdControl.setValue(this.initial);
  }

}
